module.exports = __webpack_public_path__ + "front/img/39.69c6c977.jpg";